export enum AdministrationLevels {
  TenantPlatformAdmin = 'platform.tenant.admin',
  TenantNewsAdmin = 'news.tenant.admin',
  TenantNewsMember = 'news.tenant.member',
  TenantPlatformMember = 'platform.tenant.member',
  OrganizationNewsAdmin = 'news.organization.admin',
  OrganizationPlatformAdmin = 'platform.organization.admin',
  SupportPlatformAdmin = 'platform.support.admin',
}
